import getConfig from 'next/config';
import SecondaryMenu from '../components/SecondaryMenu';
import DontWaitBannerSection from 'components/composed/sections/DontWaitBannerSection';
import * as React from 'react';
import { NextSeo } from 'next-seo';

const { publicRuntimeConfig } = getConfig();
let emailCompany = process.env.NEXT_PUBLIC_EMAIL_APP;

function Guarantee() {
  return (
    <div className="about">
      <NextSeo title="Our Guarantee" />
      <div className="top-banner">
        <div className="copy">
          <h1>Our Guarantee</h1>
        </div>
      </div>

      <SecondaryMenu />

      <div className="main-copy">
        <div className="text">
          <h2>Our Guarantee</h2>
          <h3>
            The team at Trademark Genius has its customers as its sole focus. We
            are dedicated to providing top notch service and customer support to
            our customers. We will use our knowledge, and software, to ensure
            timely processing of your order, to ensure you the fastest
            submission to the USPTO.
            <br />
            However, if you feel we haven’t lived up to our end of the bargain,
            you may request a refund by e-mail, to{' '}
            <a href={'mailto:' + emailCompany}>{emailCompany}</a> . Please note
            that USPTO Government filing fees are *non-refundable* under any
            circumstances once your application has been submitted to the United
            States Patent and Trademark Office.
          </h3>
        </div>
        <img
          className="desktop"
          src={`${publicRuntimeConfig.basePath}/about-tg.png`}
          alt=""
          layout="fill"
        />
      </div>

      <DontWaitBannerSection link="/registration-trademark" />
    </div>
  );
}

export default Guarantee;
